import React from 'react';
import PropTypes from 'prop-types';

const CheckboxFilledSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 20}`}
      height={`${height || 20}`}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.49984 18.3333H12.4998C16.6665 18.3333 18.3332 16.6667 18.3332 12.5V7.50001C18.3332 3.33334 16.6665 1.66667 12.4998 1.66667H7.49984C3.33317 1.66667 1.6665 3.33334 1.6665 7.50001V12.5C1.6665 16.6667 3.33317 18.3333 7.49984 18.3333Z"
        fill={color}
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.4585 10L8.81683 12.3583L13.5418 7.64166"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

CheckboxFilledSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default CheckboxFilledSvg;
